import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Contact = () => {
  return (
    <>
      <section className="contact-hero">
        <Container>
          <h1>Contact</h1>
          <p>
            <NavLink to="/">Home</NavLink> <span>»</span> Contact
          </p>
        </Container>
      </section>

      {/* CONTENT */}
      <section className="contact-section">
        <Container>
          <Row className="align-items-center gy-5">
            {/* LEFT INFO */}
            <Col lg={5}>
              <Row className="g-4">
                <Col md={6}>
                  <div className="info-box text-center">
                    <i
                      className="fas fa-phone-alt"
                      style={{
                        fontSize: "45px",
                        // color: "#0d6efd",
                        marginBottom: "15px",
                      }}
                    ></i>

                    <h5>For any Query?</h5>
                    <p>+91 9483484071</p>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="info-box text-center">
                    <i
                      className="fas fa-map-marker-alt"
                      style={{
                        fontSize: "45px",
                        // color: "#0d6efd",
                        marginBottom: "15px",
                      }}
                    ></i>

                    <h5>Visit anytime</h5>

                    <p>
                      3rd floor, above nest bakery, opp to irani chai, ckb
                      layout, munnekollala, marathahalli, bangalore, 560037
                    </p>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="info-box text-center">
                    <i
                      className="fas fa-envelope"
                      style={{
                        fontSize: "45px",
                        // color: "red",
                        marginBottom: "15px",
                      }}
                    ></i>

                    <h5>Write Email Us</h5>

                    <p>chipnestsemiconductor@gmail.com</p>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* RIGHT FORM */}
            <Col lg={7}>
              <div className="contact-form">
                <span className="form-subtitle">Send us email</span>
                <h2>Feel Free to write</h2>

                <Form>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Control placeholder="Enter Name" />
                    </Col>
                    <Col md={6}>
                      <Form.Control placeholder="Enter Email" />
                    </Col>
                    <Col md={6}>
                      <Form.Control placeholder="Enter Subject" />
                    </Col>
                    <Col md={6}>
                      <Form.Control placeholder="Enter Phone" />
                    </Col>
                    <Col md={12}>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Enter Message"
                      />
                    </Col>
                    <Col md={12}>
                      <Button className="send-btn">Send Message</Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
